import React from 'react';
import { CheckIcon, LockIcon, DownloadIcon, MessageCircleIcon, FileTextIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { consultingPitch, consultingTestimonial, gluteDeliverables, gluteImages, gluteProduct } from '../../data/gluteCopy';
const tracking = {
  name: gluteProduct.name,
  id: gluteProduct.id,
  price: gluteProduct.guidePrice,
  currency: gluteProduct.currency
};
export function GluteOffer() {
  return <section aria-labelledby="glute-oferta" className="w-full bg-coal" data-id="element-101" data-mp="3o341rz4k1dio">
      <div className="mx-auto w-full max-w-5xl px-5 py-16 sm:px-8 sm:py-24 lg:py-32" data-id="element-102" data-mp="3s5r1em7gw2qf">
        <div className="mx-auto max-w-2xl text-center" data-id="element-103" data-mp="3e698bun523b9">
          <p className="text-[0.68rem] font-semibold uppercase tracking-[0.22em] text-ember" data-id="element-104" data-mp="3j5lx4kxklkgh">
            La oferta
          </p>
          <h2 id="glute-oferta" className="mt-5 text-[1.9rem] font-extrabold uppercase leading-[1.02] tracking-tight text-white sm:text-5xl" data-id="element-105" data-mp="22quc4t2r7fh7">
            Recupera el control de tu físico
          </h2>
          <p className="mt-5 text-[1.02rem] leading-relaxed text-white/55 sm:text-lg" data-id="element-106" data-mp="agkc4isxm7wr">
            Deja de perder el tiempo en entrenamientos que no te dan resultados. Obtén el código
            completo hoy mismo.
          </p>
        </div>

        <div id="precio-glute" className="mt-10 scroll-mt-6 overflow-hidden rounded-2xl border border-ember/40 bg-coal-card sm:mt-14 sm:scroll-mt-10" data-id="element-107" data-mp="fdaz7q35m3ro">
          <div className="flex flex-wrap items-center justify-between gap-3 border-b border-coal-line px-6 py-4 sm:px-10" data-id="element-108" data-mp="pc05smplo1sm">
            <p className="text-[0.72rem] font-bold uppercase tracking-[0.22em] text-white" data-id="element-109" data-mp="1323nr1hg59c9">
              Acceso completo
            </p>
            <p className="inline-flex items-center gap-2 rounded-full bg-ember px-3 py-1 text-[0.68rem] font-bold uppercase tracking-wide text-coal-deep" data-id="element-110" data-mp="y4typmxyyzoy">
              <span className="h-1.5 w-1.5 rounded-full bg-coal-deep" aria-hidden="true" data-id="element-111" data-mp="18316pgaa67et" />
              Precio de lanzamiento
            </p>
          </div>

          <div className="grid lg:grid-cols-[0.8fr_1.2fr]" data-id="element-112" data-mp="1f3lhk5eju84y">
            <img src={gluteImages.ipad} alt="La guía Glute Lab abierta en un iPad" className="h-56 w-full object-cover object-center sm:h-72 lg:h-full" width={1200} height={900} data-id="element-113" data-mp="1k5auxrp8uxw7" />

            <div className="p-6 sm:p-10" data-id="element-114" data-mp="1ytyltko5ajft">
              <div className="flex gap-4" data-id="element-115" data-mp="1ysvujbmwuezd">
                <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-ember/15" aria-hidden="true" data-id="element-116" data-mp="22uqvgf0xiqcm">
                  <FileTextIcon className="h-4 w-4 text-ember" data-id="element-117" data-mp="27sahi13vc7f4" />
                </span>
                <div data-id="element-118" data-mp="2cr3xc06moaig">
                  <h3 className="text-[1.05rem] font-semibold text-white sm:text-lg" data-id="element-119" data-mp="dgcam5t17nme">
                    Glute Lab: El Código del Crecimiento
                  </h3>
                  <p className="mt-1 text-[0.9rem] leading-relaxed text-white/50" data-id="element-120" data-mp="iffehmx9znss">
                    Producto digital descargable. Todo el sistema en un solo lugar.
                  </p>
                </div>
              </div>

              <ul className="mt-6 space-y-2.5" data-id="element-121" data-mp="15uu5n6o4fnc">
                {gluteDeliverables.map(item => <li key={item.title} className="flex gap-3 text-[0.92rem] leading-snug text-white/60 sm:text-base" data-id="element-122" data-mp="3sceb7k33l1u3">
                    <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-ember" strokeWidth={3} aria-hidden="true" data-id="element-123" data-mp="ts63bm8cbovr" />
                    <span data-id="element-124" data-mp="jy5qey6thfch">{item.title}</span>
                  </li>)}
              </ul>

              <div className="mt-8 border-t border-coal-line pt-6" data-id="element-125" data-mp="ezm06ll6xheb">
                <div className="flex items-end gap-3" data-id="element-126" data-mp="34o4ugwkqr49t">
                  <span className="text-5xl font-extrabold leading-none tracking-tight text-white sm:text-6xl" data-id="element-127" data-mp="2zmz24zuztj0t">
                    ${gluteProduct.guidePrice.toFixed(2)}
                  </span>
                  <span className="pb-1 text-[0.82rem] leading-snug text-white/45 sm:text-sm" data-id="element-128" data-mp="x2qlu4ppn5gr">
                    USD · pago único.
                    <br data-id="element-129" data-mp="iff6drqer1bd" />
                    Acceso de por vida.
                  </span>
                </div>

                <CtaButton tone="ember" label="¡Quiero despertar mis glúteos ahora!" href={gluteProduct.guideCheckoutUrl} tracking={tracking} className="mt-6 w-full" data-id="element-130" data-mp="ndp16187zzwg" />

                <p className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-1.5 text-[0.78rem] text-white/40 sm:text-[0.82rem]" data-id="element-131" data-mp="113k7erfok86h">
                  <span className="inline-flex items-center gap-2" data-id="element-132" data-mp="165hxa4il618e">
                    <LockIcon className="h-4 w-4 text-ember" aria-hidden="true" data-id="element-133" data-mp="3lt9jwxswvhw0" />
                    Pago seguro
                  </span>
                  <span className="inline-flex items-center gap-2" data-id="element-134" data-mp="3qrjjdklo54nf">
                    <DownloadIcon className="h-4 w-4 text-ember" aria-hidden="true" data-id="element-135" data-mp="28upwofq6z466" />
                    Acceso inmediato
                  </span>
                  <span data-id="element-136" data-mp="2hwpbr2hnby6h">Sin mensualidades</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start gap-6 border-t border-coal-line pt-8 sm:mt-14 lg:flex-row lg:items-center lg:justify-between lg:gap-10" data-id="element-137" data-mp="2dwoyvma73v1j">
          <div data-id="element-138" data-mp="1l6yh939cub0o">
            <h3 className="text-[1.02rem] font-semibold text-white sm:text-lg" data-id="element-139" data-mp="1l7honq1dph0g">
              {consultingPitch.title}
            </h3>
            <p className="mt-1.5 max-w-xl text-[0.92rem] leading-relaxed text-white/50 sm:text-base" data-id="element-140" data-mp="1yzo419wpjjyu">
              {consultingPitch.text}
            </p>

            <figure className="mt-5 max-w-xl border-l-2 border-ember pl-4" data-id="element-141" data-mp="16haerypft6bd">
              <blockquote className="text-[0.9rem] leading-relaxed text-white/70" data-id="element-142" data-mp="12g71njyrxodu">
                “{consultingTestimonial.quote}”
              </blockquote>
              <figcaption className="mt-2 text-[0.78rem] text-white/40" data-id="element-143" data-mp="31kfjh6skjv99">
                <span className="font-semibold text-white/70" data-id="element-144" data-mp="36j9yryrbv1om">{consultingTestimonial.name}</span> ·{' '}
                {consultingTestimonial.detail}
              </figcaption>
            </figure>
          </div>

          <a href={gluteProduct.consultingUrl} target="_blank" rel="noopener noreferrer" className="inline-flex shrink-0 items-center justify-center gap-2 rounded-lg border border-ember px-5 py-3 text-[0.85rem] font-semibold text-ember outline-none transition-colors duration-150 ease-smooth hover:bg-ember hover:text-coal-deep focus-visible:ring-4 focus-visible:ring-ember/40 sm:text-sm" data-id="element-145" data-mp="3g8jrngtzwods">
            <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-146" data-mp="7u1r006dwb47" />
            {consultingPitch.cta}
          </a>
        </div>
      </div>
    </section>;
}